module.exports = __webpack_public_path__ + "assets/img/yyzzbg2.4973c51c.png";